import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

import { StepperStatus, CanContinue, StepperAction } from "../models/common/StepperStatus";
import { PreneedSalesSections } from "../models/sales/sale-steps";
import { StepperActionType } from "../models/common/enums";

@Injectable()
export class NavigationService {
  private stepperStatus: StepperStatus;
  private stepperAction: StepperAction;
  private continue: CanContinue;

  stepperStatusSource: Subject<StepperStatus>;
  closeApplicationSource: Subject<boolean> = new BehaviorSubject<boolean>(false);
  moveStepperSource: Subject<StepperAction>;
  sumbitApplicationSource: Subject<boolean> = new BehaviorSubject<boolean>(false);
  newApplicationSource: Subject<boolean> = new BehaviorSubject<boolean>(false);
  canContinue: Subject<CanContinue>;
  nextStepIndex: Subject<Number> = new BehaviorSubject<Number>(0);

  constructor() {
    this.stepperStatusSource= new BehaviorSubject<StepperStatus>(this.stepperStatus);
    this.moveStepperSource = new BehaviorSubject<StepperAction>(this.stepperAction);
    this.canContinue = new BehaviorSubject<CanContinue>(this.continue);

   }


  updateStepperStatus(stepperStatus: StepperStatus): void {
    this.stepperStatus = stepperStatus;
    //console.log("Update StepperStatus", this.stepperStatus);
    this.stepperStatusSource.next(stepperStatus);
  }

  getStepperStatus() {
    return this.stepperStatus;
  }

  continueToNextStep(currentStep: PreneedSalesSections) {
    if (this.stepperStatus.CurrentStep === currentStep) {
      let stepperCurrentAction = new StepperAction(StepperActionType.GoNext, currentStep);
      this.moveStepperSource.next(stepperCurrentAction);
    }

  }

  goBackStep(currentStep: PreneedSalesSections) {
    let stepperCurrentAction = new StepperAction(StepperActionType.GoBack, currentStep);
    this.moveStepperSource.next(stepperCurrentAction);

  }

  updateCanContinue(canContinue: CanContinue) {
    this.canContinue.next(canContinue);
  }

  closeApplication() {
    this.closeApplicationSource.next(true);
    //Clear object
    // let stpepperStatusClear = new StepperStatus(PreneedSalesSections.None,false,false,false); 
    // this.updateStepperStatus(stpepperStatusClear); 
    this.moveStepperSource.next(null);
  }

  clearStepperStatus() {
    //this.stepperStatusSource.unsubscribe();
    this.stepperStatusSource.next(null);
  }

  checkAndMoveStepper(moveAction: StepperAction, componentStep: PreneedSalesSections) {

    if (moveAction !== null && moveAction !== undefined && moveAction.CurrentStep === componentStep) {
      return moveAction.ActionType;
    }
    return StepperActionType.None;
  }

  sumbitApplication() {
    this.sumbitApplicationSource.next(true);
  }


  newApplication() {
    this.newApplicationSource.next(true);
    //this.newApplicationSource.complete();
  }

  updateSteperStatusFromPreneed(stepIndex: number, isSecondaryAddresseActive: boolean = false, isAccFlow: boolean = false) {
    //console.log("Steper Current Step => ", stepIndex);
    this.nextStepIndex.next(stepIndex);

    if (isAccFlow) {
      switch (stepIndex) {
        case PreneedSalesSections.BeneficiaryStep:
          stepIndex = PreneedSalesSections.BeneficiaryStepACC;
          break;
      }
    }

    switch (stepIndex) {
      case PreneedSalesSections.None:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.None,
          false,
          false,
          true
        );
        break;

      case PreneedSalesSections.PreQuestions:

        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.PreQuestions,
          false,
          false,
          true
        );
        break;

      case PreneedSalesSections.OptionalHealthQuestions:

        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.OptionalHealthQuestions,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.HealthQuestionsPartA:

        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.HealthQuestionsPartA,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.HealthQuestionsPartB:

        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.HealthQuestionsPartB,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.RateStep:

        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.RateStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.RateStepACC:

        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.RateStepACC,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.ReplacementStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.ReplacementStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.ProposedInsuredStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.ProposedInsuredStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.SecondaryAddresseeStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.SecondaryAddresseeStep,
          true,
          true,
          true
        );
        break;

      case PreneedSalesSections.OwnerInformationStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.OwnerInformationStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.BeneficiaryStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.BeneficiaryStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.BeneficiaryStepACC:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.BeneficiaryStepACC,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.CurrentPhysicianStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.CurrentPhysicianStep,
          true,
          true,
          true
        );
        break;

      case PreneedSalesSections.PaymentInformationStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.PaymentInformationStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.AgentInformationStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.AgentInformationStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.ReviewAndSignStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.ReviewAndSignStep,
          false,
          true,
          true
        );
        break;

      case PreneedSalesSections.ConfirmationStep:
        this.stepperStatus = new StepperStatus(
          PreneedSalesSections.ConfirmationStep,
          false,
          false,
          true
        );
        break;
    }

    this.updateStepperStatus(this.stepperStatus);
  }
}
